const coachbar = {
  earningbar: {
    chart: {
      type: "bar",
      height: 350,
      width: "100%",
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        columnWidth: "55%",
      },
    },
    stroke: {
      show: true,
      width: 3,
      colors: ["transparent"],
    },

    labels: [
      2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020,
    ],
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "#777",
        },
      },
    },
    title: {
      text: "",
      align: "left",
      style: {
        fontSize: "18px",
      },
    },
  },
  series: [
    {
      color: "#AAF40C",
      data: [420, 532, 516, 575, 519, 517, 454, 392, 262, 383, 446, 551],
    },
    {
      color: "#097E52",
      data: [336, 612, 344, 647, 345, 563, 256, 344, 323, 300, 455, 456],
    },
  ],
};
export { coachbar };
